import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { useFormSubmit } from "melco-shared-logic";
import { DisplayLoginForm } from "./DisplayLoginForm";
import { useLogin } from "../../hooks/login/useLogin";

export type LoginFormValueType = {
  password: string;
};

const initialValues: LoginFormValueType = {
  password: "",
};

type LoginFormProps = {
  view_id: string | undefined;
  access_token: string | null;
  user_id: number | undefined;
};

export const LoginForm: React.FC<LoginFormProps> = ({
  view_id,
  access_token,
  user_id
}) => {
  const navigate = useNavigate();

  const login = useLogin();

  const onSubmit = useFormSubmit(
    async (values: LoginFormValueType) => {
      const { password } = values;

      try {
        const loginResponse = await login({ password, view_id, access_token });
        if (loginResponse) {
          navigate("/view", {
            state: {
              password,
              view_id,
              access_token,
              apiResponse: loginResponse,
              user_id: user_id
            },
          });
        }
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    { translationPrefix: "loginpage" }
  );

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      {(props) => <DisplayLoginForm {...props} />}
    </Formik>
  );
};
